export const VENUE_TYPES = [
  "RESTAURANT",
  "CAFE",
  "BAR_PUB",
  "HOTPOT_BBQ",
  "FAST_FOOD",
  "BAKERY",
  "OTHER",
] as const;

export type VenueType = (typeof VENUE_TYPES)[number];

export const VENUE_TYPE_LABEL_VI: Record<VenueType, string> = {
  RESTAURANT: "Nhà hàng",
  CAFE: "Café",
  BAR_PUB: "Bar / Pub",
  HOTPOT_BBQ: "Lẩu / Nướng",
  FAST_FOOD: "Fastfood",
  BAKERY: "Bakery / Bánh ngọt",
  OTHER: "Khác",
};
